import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Styles from "../Styles";

const ContactFieldRow = ({ styles, label, lines = 1, labelWidth = 58 }) => (
  <View
    style={{
      width: "100%",
      flexDirection: "row",
      alignItems: "flex-start",
      marginBottom: lines > 1 ? 4 : 3,
    }}
  >
    <Text
      style={{
        ...styles.ButtonTextSmall,
        width: labelWidth,
        flexShrink: 0,
        marginRight: label ? 6 : 0,
      }}
      wrap={false}
    >
      {label}
    </Text>

    <View style={{ flex: 1 }}>
      {Array.from({ length: lines }).map((_, index) => (
        <View
          key={index}
          style={{
            ...styles.line,
            flexGrow: 0,
            marginTop: index === 0 ? 0 : 3,
          }}
        />
      ))}
    </View>
  </View>
);

const ContactCard = ({ styles, title }) => (
  <View style={{ width: "48%" }}>
    <Text style={{ ...styles.LabelSmallSemiBold, marginBottom: 3 }}>
      {title}
    </Text>
    <ContactFieldRow styles={styles} label="Name" />
    <ContactFieldRow styles={styles} label="Address" lines={2} />
    <ContactFieldRow styles={styles} label="Tel No." />
  </View>
);

const UsefulContacts = ({ primaryColor = "081e56" }) => {
  const styles = Styles(primaryColor);

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <Text style={styles.ContentSemiBold}>Useful Contacts</Text>

      <View style={styles.panel}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            marginBottom: 6,
            gap: 20,
          }}
        >
          <View style={{ width: "48%" }}>
            <Text
              style={{
                ...styles.LabelSmallSemiBold,
                marginBottom: 3,
              }}
            >
              Income Tax
            </Text>
            <Text
              style={{
                ...styles.ButtonTextSmall,
                marginBottom: 3,
              }}
            >
              The tax office that deals with my affairs is
            </Text>
            <ContactFieldRow styles={styles} label="" labelWidth={0} />
            <ContactFieldRow
              styles={styles}
              label="Reference No."
              labelWidth={58}
            />
            <ContactFieldRow styles={styles} label="Tel No." labelWidth={58} />
          </View>

          <ContactCard styles={styles} title="Accountant" />
        </View>

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            marginBottom: 6,
            gap: 20,
          }}
        >
          <ContactCard styles={styles} title="Solicitor" />
          <ContactCard styles={styles} title="Financial Adviser" />
        </View>

        <Text
          style={{
            ...styles.LabelSmallSemiBold,
            marginBottom: 3,
          }}
        >
          In the event of my death please contact
        </Text>

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            gap: 20,
          }}
        >
          <View style={{ width: "48%" }}>
            <ContactFieldRow styles={styles} label="Name" />
            <ContactFieldRow styles={styles} label="Address" lines={2} />
            <ContactFieldRow styles={styles} label="Tel No." />
          </View>

          <View style={{ width: "48%" }}>
            <ContactFieldRow styles={styles} label="Name" />
            <ContactFieldRow styles={styles} label="Address" lines={2} />
            <ContactFieldRow styles={styles} label="Tel No." />
          </View>
        </View>
      </View>
    </View>
  );
};

export default UsefulContacts;
